<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <!-- <el-breadcrumb-item :to="{ path: '/stp/' }">CP列表</el-breadcrumb-item> -->
        <el-breadcrumb-item
          :to="{
          name: 'library',
          query: {
            cpid: this.$route.query.cpid
          }
        }"
        >书籍管理</el-breadcrumb-item>
        <el-breadcrumb-item>批量添加书籍</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;">批量设置书籍信息</span>
      </div>
      <div class="main-box">
        <el-form ref="formCustom" :inline="true" label-width="125px" :model="formCustom">
          <el-form-item label="书籍面码: " label-width="120px">
            <div class="oidstyle">
              <el-input style="width: 150px" v-model="formCustom.OID" />
              <getOID @updateOID="updateOIDHandle" mode="edit" code="cover"></getOID>
            </div>
          </el-form-item>
          <br />
          <el-form-item label="书籍品牌: " label-width="120px">
            <BrandChose
              :brandName="formCustom.brand"
              doWhatTemp="edit"
              @brandChose="brandChoseHandle"
            />
          </el-form-item>
          <br />
          <el-form-item label="书籍等级: " label-width="120px">
            <el-input style="width: 300px" v-model="formCustom.level" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <br />
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;">批量上传pdf</span>
      </div>
      <div class="main-box">
        <Upload
          accept="application/pdf,application/zip"
          ref="picUploader"
          type="drag"
          :show-upload-list="false"
          action="/aries-api/resource/upload"
          :data="uploadPicData"
          multiple
          :before-upload="handlePicBeforeUpload"
          :on-success="handlePicSuccess"
          style="width:130px;height:130px"
          v-if="uploading==false"
        >
          <div style="padding: 48px 0">
            <Icon type="ios-cloud-upload" size="32" color="#3399ff"></Icon>
          </div>
        </Upload>
        <div v-if="uploading==true">
          <Progress :percent="uploadPercent" status="active" />
          <span>上传进度:{{totalNeedUpload-picUploadNum}}/{{totalNeedUpload}}</span>
          <br />
          <List item-layout="vertical">
            <ListItem v-for="(item,index) in uploadStatus" :key="index">
              <ListItemMeta :title="item.name" :description="item.status" />
              <template slot="extra">
                <i
                  class="el-icon-check"
                  style="color:#44ee44;font-size:20px"
                  v-if="item.status=='success'"
                />
                <i
                  class="el-icon-close"
                  style="color:#ee4444;font-size:20px"
                  v-if="item.status!='success'"
                />
              </template>
            </ListItem>
          </List>
        </div>
      </div>
    </el-card>
    <br />
    <div v-if="multyData.length>0">
      <el-card>
        <div slot="header" class="clearfix">
          <span style="line-height: 36px;">请确认批量信息</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="multyData"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column prop="name" label="书籍名称" align="center" width="300" sortable>
            <template slot-scope="scope">
              <el-input style="width: 220px" v-model="scope.row.name" />
            </template>
          </el-table-column>
          <el-table-column label="书籍品牌" align="center" width="250">
            <template slot-scope="scope">
              <BrandChose
                :brandName="scope.row.content.brand"
                doWhatTemp="edit"
                @brandChose="(name, id, tagIndex) => {brandChoseSingle(scope.row.name, name, id, tagIndex)}"
              />
            </template>
          </el-table-column>
          <el-table-column label="级别" align="center" width="180">
            <template slot-scope="scope">
              <el-input style="width: 120px" v-model="scope.row.content.level" />
            </template>
          </el-table-column>
          <el-table-column label="书面码" align="center" width="180">
            <template slot-scope="scope">
              <el-input style="width: 120px" v-model="scope.row.content.OID" />
            </template>
          </el-table-column>
          <el-table-column label="书籍说明" align="center" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.content.desc}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            show-overflow-tooltip
            align="center"
            width="150"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button type="info" size="mini" @click="handleDelete(scope.row.name)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-button size="small" @click="saveCancel">取消</el-button>
        <el-button size="small" type="primary" @click="saveConfirm">确定</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import { checkFormat } from "./book";
import getOID from "./components/getOID";
import BrandChose from "./components/addBook/BrandChose";
export default {
  name: "addbook",
  components: {
    getOID,
    BrandChose,
  },
  data() {
    return {
      formCustom: {
        OID: "",
        level: "",
        brand: "",
      },
      uploadPicData: {
        isOnlyMP3: "false",
        pdfToPng: "true",
        retainPdf: "true",
      },
      brandId: null,
      uploading: false,
      uploadPercent: 0,
      picUploadNum: 0,
      everyProgress: 0,
      totalNeedUpload: 0,
      uploadStatus: [],
      multyData: [],
    };
  },
  created() {
    document.title = "点读笔-批量添加书籍";
  },
  watch: {},
  methods: {
    brandChoseHandle(name, id) {
      this.brandId = id;
      this.formCustom.brand = name;
    },
    updateOIDHandle(oid) {
      if (typeof oid == "string") {
        this.formCustom.OID = oid;
      }
    },
    fetchBooklist(name) {
      return new Promise((resolve, reject) => {
        let temp = {
          appId: this.$API.APPID,
          dbId: [Number(this.$route.query.cpid)],
          name: name,
          pageSize: 100,
        };
        this.$axios
          .post("/aries-api/resource/list", temp)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              resolve(JSON.stringify(response.data.data.list));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handlePicBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        let findName = false;
        let nameTemp = file.name.split(".")[0];
        let temp = {
          appId: this.$API.APPID,
          dbId: [Number(this.$route.query.cpid)],
          name: nameTemp,
          pageSize: 100,
        };
        this.$axios
          .post("/aries-api/resource/list", temp)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              for (let i = 0; i < response.data.data.list.length; ++i) {
                if (nameTemp == response.data.data.list[i].name) {
                  console.log("find");
                  findName = true;
                }
              }
              if (findName) {
                reject();
              } else {
                this.picUploadNum += 1;
                this.totalNeedUpload = this.picUploadNum;
                this.everyProgress = parseInt(100 / this.picUploadNum);
                this.uploadPercent = 0;
                this.uploading = true;
                let stuTemp = {
                  status: "",
                  name: nameTemp,
                  pdf: "",
                  pages: null,
                };
                this.uploadStatus.push(stuTemp);
                resolve();
              }
            } else {
              reject();
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject();
          });
      });
    },
    handlePicSuccess(response, file, fileList) {
      console.log(response);
      this.picUploadNum -= 1;
      this.uploadPercent += this.everyProgress;
      let pages = [];
      let stuTemp = null;
      if (response.result == 0) {
        let len = response.data.length;
        for (let i = 1; i < len; ++i) {
          let imageList = [];
          imageList.push(response.data[i].url);
          let pageParam = {
            name: response.data[i].name,
            image: imageList,
          };
          pages.push(pageParam);
        }
        let bookName = response.data[0].pdfName.split(".")[0];
        for (let i = 0; i < this.uploadStatus.length; ++i) {
          if (bookName === this.uploadStatus[i].name) {
            this.uploadStatus[i].status = response.msg;
            this.uploadStatus[i].pdf = response.data[0].url;
            this.uploadStatus[i].pages = pages;
            this.initData(this.uploadStatus[i]);
            break;
          }
        }
        /*
        stuTemp = {
          status: response.msg,
          name: nameAry[0],
          pdf: response.data[0].url,
          pages: pages,
        };
        */
      } else {
        let bookName = file.name.split(".")[0];
        console.log(bookName);
        for (let i = 0; i < this.uploadStatus.length; ++i) {
          if (bookName === this.uploadStatus[i].name) {
            this.uploadStatus[i].status = response.msg;
            this.uploadStatus[i].pages = pages;
            this.initData(this.uploadStatus[i]);
            break;
          }
        }
        /*
        let nameAry = file.name.split(".");
        stuTemp = {
          status: response.msg,
          name: nameAry[0],
          pdf: "",
          pages: pages,
        };
        */
      }

      //this.initData(stuTemp);
      if (this.picUploadNum === 0) {
        this.uploadPercent = 100;
      }
    },
    initData(stuTemp) {
      let content = {
        OID: this.formCustom.OID,
        brand: this.formCustom.brand,
        image: "",
        level: this.formCustom.level,
        pdf: stuTemp.pdf,
        pages: stuTemp.pages,
        desc: "",
      };
      if (stuTemp.status != "success") {
        content.desc = "PDF上传失败";
      }
      let params = {
        appId: this.$API.APPID,
        clevel: 2,
        content: content,
        dbId: Number(this.$route.query.cpid),
        id: 0,
        name: stuTemp.name,
        type: 10,
      };
      if (this.brandId != null) {
        params.tagIds = [];
        params.tagIds.push(this.brandId);
      }
      if (this.formCustom.level != "") {
        params.keywords = this.formCustom.level;
      }
      this.multyData.push(params);
    },
    brandChoseSingle(name, brand, id, tagIndex) {
      for (let i = 0; i < this.multyData.length; ++i) {
        if (name == this.multyData[i].name) {
          this.multyData[i].content.brand = brand;
          if (id != null) {
            this.multyData[i].tagIds = [];
            this.multyData[i].tagIds.push(id);
          }
          break;
        }
      }
    },
    handleDelete(name) {
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除书籍</li></ul>",
        onOk: () => {
          for (let i = 0; i < this.multyData.length; ++i) {
            if (name == this.multyData[i].name) {
              this.multyData.splice(i, 1);
              break;
            }
          }
        },
      });
    },
    saveCancel() {
      this.$router.push({
        name: "library",
        query: {
          cpid: this.$route.query.cpid,
        },
      });
    },
    saveConfirm() {
      let len = this.multyData.length;
      let totalSave = 0;
      for (let i = 0; i < this.multyData.length; ++i) {
        this.multyData[i].keywords = this.multyData[i].content.level;
        this.$axios
          .post("/aries-api/resource/save", this.multyData[i])
          .then((response) => {
            // debugger
            console.log(response);
            if (!response.data || response.data.result == "0") {
              totalSave++;
              // this.$router.push({
              //    name: "library",
              //  });
              if (totalSave == len) {
                this.saveCancel();
              }
            } else {
              alert(
                "post failed:" + response.data.result + ". " + response.data.msg
              );
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      }
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";

</style>



// WEBPACK FOOTER //
// multyaddbook.vue?6c6cbecc